<p-dialog
  [header]="header()"
  [closable]="!submitting()"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
>
  <p class="confirm-text">
    @if (entityName()) {
      Delete <strong>{{ entityName() }}</strong>?
    } @else {
      Delete this {{ entityKind() }}?
    }
  </p>

  <div class="field">
    <p-selectbutton
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      [disabled]="submitting()"
      [ngModel]="selectedMode()"
      [options]="modeOptions"
      (ngModelChange)="selectedMode.set($event)"
    ></p-selectbutton>
  </div>

  <p-message
    styleClass="delete-warning"
    [severity]="isHard() ? 'error' : 'warn'"
    [text]="warning()"
  ></p-message>

  @if (isHard()) {
    <p class="confirm-prompt">Type <strong>DELETE</strong> to confirm.</p>
    <input
      pInputText
      class="confirm-input"
      autocomplete="off"
      placeholder="DELETE"
      [disabled]="submitting()"
      [ngModel]="confirmText()"
      (ngModelChange)="confirmText.set($event)"
    />
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [disabled]="submitting()"
      [text]="true"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      icon="pi pi-trash"
      severity="danger"
      [label]="confirmLabel()"
      [disabled]="!canConfirm()"
      [loading]="submitting()"
      (onClick)="onConfirm()"
    ></p-button>
  </ng-template>
</p-dialog>
